/**
 * EDUHUB i18n dictionaries.
 *
 * EN is the source of truth. The other five locales were generated via an
 * LLM-assisted translation pass and reviewed for terminology consistency in
 * an EDU / academic context. Add new keys to EN first, then mirror.
 */

const EN = {
  "nav.courses": "Courses",
  "nav.playground": "Playground",
  "nav.howItWorks": "How it works",
  "nav.about": "About",
  "nav.dashboard": "Dashboard",
  "nav.admin": "Admin",
  "nav.signin": "Sign in",
  "nav.enroll": "Enroll",
  "nav.signout": "Sign out",
  "hero.eyebrow": "EDUHUB — A school ",
  "hero.title.line1": "Classical teaching.",
  "hero.title.line2": "Modern craft.",
  "hero.body":
    "Live, small-cohort tutorials taught by real practitioners. From Python to power systems, from Romanian to robotics — built like a university, paced like a startup.",
  "hero.cta.primary": "Browse courses",
  "hero.cta.secondary": "How it works",
  "hero.typing.prefix": "Now teaching",
  "section.categories": "Disciplines",
  "section.featured": "Featured this semester",
  "section.how": "How EDUHUB works",
  "step1.title": "Choose your discipline",
  "step1.body":
    "Forty-seven courses across programming, engineering, sciences and languages. Each tagged by level and lab requirements.",
  "step2.title": "Enroll & pay securely",
  "step2.body":
    "Stripe checkout in your currency. A class only begins when the minimum cohort is reached — you are reserved a seat.",
  "step3.title": "Book your time",
  "step3.body":
    "Pick from your teacher’s available calendar. Join live from laptop, or phone for non-programming courses.",
  "step4.title": "Earn the certificate",
  "step4.body":
    "Complete the curriculum and your teacher issues a verifiable EDUHUB certificate of completion.",
  "course.beginner": "Beginner",
  "course.intermediate": "Intermediate",
  "course.advanced": "Advanced",
  "course.viewDetails": "View details",
  "course.enroll": "Enroll",
  "course.enrolled": "Enrolled",
  "course.minStudents": "Min. cohort",
  "course.hours": "hours",
  "course.laptopRequired": "Laptop required",
  "course.phoneAllowed": "Phone or laptop",
  "footer.tagline": "A premium academy.",
  "footer.copy": "© 2026 EDUHUB. All rights reserved.",
  "footer.discipl": "Disciplines",
  "footer.company": "Company",
  "footer.legal": "Legal",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Full name",
  "auth.signin": "Sign in",
  "auth.signup": "Create account",
  "auth.haveAccount": "Already have an account?",
  "auth.noAccount": "New to EDUHUB?",
  "common.loading": "Loading…",
  "common.search": "Search courses",
  "common.allLevels": "All levels",
  "common.allCategories": "All disciplines",
  "courses.eyebrow": "All courses",
  "courses.title": "The catalogue.",
  "courses.subtitle":
    "Forty-seven live courses across ten disciplines. Pick a level. Reserve your seat.",
  "course.from": "From",
  "course.enrolledLabel": "enrolled",
  "course.toCohort": "to cohort",
};

const RO = {
  "nav.courses": "Cursuri",
  "nav.playground": "Laborator",
  "nav.howItWorks": "Cum funcționează",
  "nav.about": "Despre",
  "nav.dashboard": "Cont",
  "nav.admin": "Admin",
  "nav.signin": "Autentificare",
  "nav.enroll": "Înscriere",
  "nav.signout": "Deconectare",
  "hero.eyebrow": "EDUHUB — O școală de MikkSysTech",
  "hero.title.line1": "Predare clasică.",
  "hero.title.line2": "Meșteșug modern.",
  "hero.body":
    "Tutoriale live, în grupuri mici, predate de profesioniști reali. De la Python la sisteme de putere, de la română la robotică — construit ca o universitate, ritmat ca un startup.",
  "hero.cta.primary": "Vezi cursurile",
  "hero.cta.secondary": "Cum funcționează",
  "hero.typing.prefix": "Predăm acum",
  "section.categories": "Discipline",
  "section.featured": "Recomandate acest semestru",
  "section.how": "Cum funcționează EDUHUB",
  "step1.title": "Alege disciplina",
  "step1.body":
    "Patruzeci și șapte de cursuri: programare, inginerie, științe, limbi. Fiecare etichetat după nivel și cerințe de laborator.",
  "step2.title": "Înscrie-te și plătește securizat",
  "step2.body":
    "Stripe în moneda ta. Cursul începe doar când se atinge cohorta minimă — locul tău este rezervat.",
  "step3.title": "Rezervă-ți timpul",
  "step3.body":
    "Alege din calendarul profesorului. Conectează-te live de pe laptop sau telefon (pt. non-programare).",
  "step4.title": "Obține certificatul",
  "step4.body":
    "Termini curriculumul, profesorul îți eliberează un certificat EDUHUB verificabil.",
  "course.beginner": "Începător",
  "course.intermediate": "Intermediar",
  "course.advanced": "Avansat",
  "course.viewDetails": "Vezi detalii",
  "course.enroll": "Înscriere",
  "course.enrolled": "Înscris",
  "course.minStudents": "Cohortă min.",
  "course.hours": "ore",
  "course.laptopRequired": "Laptop obligatoriu",
  "course.phoneAllowed": "Telefon sau laptop",
  "footer.tagline": "O academie premium de MikkSysTech.",
  "footer.copy": "© 2026 EDUHUB. Toate drepturile rezervate.",
  "footer.discipl": "Discipline",
  "footer.company": "Companie",
  "footer.legal": "Legal",
  "auth.email": "Email",
  "auth.password": "Parolă",
  "auth.name": "Nume complet",
  "auth.signin": "Autentificare",
  "auth.signup": "Creează cont",
  "auth.haveAccount": "Ai deja cont?",
  "auth.noAccount": "Nou pe EDUHUB?",
  "common.loading": "Se încarcă…",
  "common.search": "Caută cursuri",
  "common.allLevels": "Toate nivelurile",
  "common.allCategories": "Toate disciplinele",
  "courses.eyebrow": "Toate cursurile",
  "courses.title": "Catalogul.",
  "courses.subtitle":
    "Patruzeci și șapte de cursuri live, în zece discipline. Alege un nivel. Rezervă-ți locul.",
  "course.from": "De la",
  "course.enrolledLabel": "înscriși",
  "course.toCohort": "până la cohortă",
};

const ES = {
  "nav.courses": "Cursos",
  "nav.playground": "Laboratorio",
  "nav.howItWorks": "Cómo funciona",
  "nav.about": "Acerca de",
  "nav.dashboard": "Panel",
  "nav.admin": "Admin",
  "nav.signin": "Iniciar sesión",
  "nav.enroll": "Inscribirse",
  "nav.signout": "Cerrar sesión",
  "hero.eyebrow": "EDUHUB — Una escuela de MikkSysTech",
  "hero.title.line1": "Enseñanza clásica.",
  "hero.title.line2": "Oficio moderno.",
  "hero.body":
    "Tutoriales en vivo, en cohortes pequeñas, impartidos por profesionales reales. De Python a sistemas de potencia, del rumano a la robótica — construido como una universidad, con el ritmo de una startup.",
  "hero.cta.primary": "Ver cursos",
  "hero.cta.secondary": "Cómo funciona",
  "hero.typing.prefix": "Enseñando ahora",
  "section.categories": "Disciplinas",
  "section.featured": "Destacados este semestre",
  "section.how": "Cómo funciona EDUHUB",
  "step1.title": "Elige tu disciplina",
  "step1.body":
    "Cuarenta y siete cursos en programación, ingeniería, ciencias e idiomas. Cada uno con nivel y requisitos de laboratorio.",
  "step2.title": "Inscríbete y paga con seguridad",
  "step2.body":
    "Stripe en tu moneda. Una clase comienza solo cuando se alcanza la cohorte mínima — tu plaza queda reservada.",
  "step3.title": "Reserva tu horario",
  "step3.body":
    "Elige del calendario disponible de tu profesor. Únete en vivo desde laptop o teléfono (excepto programación).",
  "step4.title": "Obtén el certificado",
  "step4.body":
    "Completa el plan de estudios y tu profesor emite un certificado EDUHUB verificable.",
  "course.beginner": "Principiante",
  "course.intermediate": "Intermedio",
  "course.advanced": "Avanzado",
  "course.viewDetails": "Ver detalles",
  "course.enroll": "Inscribirse",
  "course.enrolled": "Inscrito",
  "course.minStudents": "Cohorte mín.",
  "course.hours": "horas",
  "course.laptopRequired": "Laptop requerida",
  "course.phoneAllowed": "Teléfono o laptop",
  "footer.tagline": "Una academia premium de MikkSysTech.",
  "footer.copy": "© 2026 EDUHUB. Todos los derechos reservados.",
  "footer.discipl": "Disciplinas",
  "footer.company": "Empresa",
  "footer.legal": "Legal",
  "auth.email": "Correo",
  "auth.password": "Contraseña",
  "auth.name": "Nombre completo",
  "auth.signin": "Iniciar sesión",
  "auth.signup": "Crear cuenta",
  "auth.haveAccount": "¿Ya tienes una cuenta?",
  "auth.noAccount": "¿Nuevo en EDUHUB?",
  "common.loading": "Cargando…",
  "common.search": "Buscar cursos",
  "common.allLevels": "Todos los niveles",
  "common.allCategories": "Todas las disciplinas",
  "courses.eyebrow": "Todos los cursos",
  "courses.title": "El catálogo.",
  "courses.subtitle":
    "Cuarenta y siete cursos en vivo, en diez disciplinas. Elige un nivel. Reserva tu plaza.",
  "course.from": "Desde",
  "course.enrolledLabel": "inscritos",
  "course.toCohort": "hasta cohorte",
};

const FR = {
  "nav.courses": "Cours",
  "nav.playground": "Atelier",
  "nav.howItWorks": "Comment ça marche",
  "nav.about": "À propos",
  "nav.dashboard": "Tableau de bord",
  "nav.admin": "Admin",
  "nav.signin": "Se connecter",
  "nav.enroll": "S’inscrire",
  "nav.signout": "Se déconnecter",
  "hero.eyebrow": "EDUHUB — Une école de MikkSysTech",
  "hero.title.line1": "Enseignement classique.",
  "hero.title.line2": "Artisanat moderne.",
  "hero.body":
    "Cours en direct, en petites cohortes, dispensés par de vrais praticiens. De Python aux systèmes de puissance, du roumain à la robotique — construit comme une université, au rythme d’une startup.",
  "hero.cta.primary": "Voir les cours",
  "hero.cta.secondary": "Comment ça marche",
  "hero.typing.prefix": "Nous enseignons",
  "section.categories": "Disciplines",
  "section.featured": "À l’affiche ce semestre",
  "section.how": "Comment fonctionne EDUHUB",
  "step1.title": "Choisissez votre discipline",
  "step1.body":
    "Quarante-sept cours en programmation, ingénierie, sciences et langues. Chacun étiqueté par niveau et exigences de laboratoire.",
  "step2.title": "Inscrivez-vous et payez en toute sécurité",
  "step2.body":
    "Paiement Stripe dans votre devise. Un cours ne commence qu’une fois la cohorte minimale atteinte — votre place est réservée.",
  "step3.title": "Réservez votre créneau",
  "step3.body":
    "Choisissez parmi le calendrier de votre professeur. Rejoignez en direct depuis un ordinateur ou un téléphone (hors programmation).",
  "step4.title": "Obtenez votre certificat",
  "step4.body":
    "Terminez le cursus et votre professeur délivre un certificat EDUHUB vérifiable.",
  "course.beginner": "Débutant",
  "course.intermediate": "Intermédiaire",
  "course.advanced": "Avancé",
  "course.viewDetails": "Voir les détails",
  "course.enroll": "S’inscrire",
  "course.enrolled": "Inscrit",
  "course.minStudents": "Cohorte min.",
  "course.hours": "heures",
  "course.laptopRequired": "Ordinateur requis",
  "course.phoneAllowed": "Téléphone ou ordinateur",
  "footer.tagline": "Une académie premium par MikkSysTech.",
  "footer.copy": "© 2026 EDUHUB. Tous droits réservés.",
  "footer.discipl": "Disciplines",
  "footer.company": "Société",
  "footer.legal": "Mentions légales",
  "auth.email": "E-mail",
  "auth.password": "Mot de passe",
  "auth.name": "Nom complet",
  "auth.signin": "Se connecter",
  "auth.signup": "Créer un compte",
  "auth.haveAccount": "Vous avez déjà un compte ?",
  "auth.noAccount": "Nouveau sur EDUHUB ?",
  "common.loading": "Chargement…",
  "common.search": "Rechercher des cours",
  "common.allLevels": "Tous les niveaux",
  "common.allCategories": "Toutes les disciplines",
  "courses.eyebrow": "Tous les cours",
  "courses.title": "Le catalogue.",
  "courses.subtitle":
    "Quarante-sept cours en direct, dans dix disciplines. Choisissez un niveau. Réservez votre place.",
  "course.from": "À partir de",
  "course.enrolledLabel": "inscrits",
  "course.toCohort": "vers cohorte",
};

const DE = {
  "nav.courses": "Kurse",
  "nav.playground": "Werkstatt",
  "nav.howItWorks": "So funktioniert es",
  "nav.about": "Über uns",
  "nav.dashboard": "Dashboard",
  "nav.admin": "Admin",
  "nav.signin": "Anmelden",
  "nav.enroll": "Einschreiben",
  "nav.signout": "Abmelden",
  "hero.eyebrow": "EDUHUB — Eine Schule von MikkSysTech",
  "hero.title.line1": "Klassischer Unterricht.",
  "hero.title.line2": "Modernes Handwerk.",
  "hero.body":
    "Live-Unterricht in kleinen Gruppen, von echten Praktikern gehalten. Von Python bis zu Energiesystemen, vom Rumänischen bis zur Robotik — gebaut wie eine Universität, im Tempo eines Startups.",
  "hero.cta.primary": "Kurse ansehen",
  "hero.cta.secondary": "So funktioniert es",
  "hero.typing.prefix": "Wir unterrichten",
  "section.categories": "Disziplinen",
  "section.featured": "Diesen Semester empfohlen",
  "section.how": "So funktioniert EDUHUB",
  "step1.title": "Wähle deine Disziplin",
  "step1.body":
    "Siebenundvierzig Kurse in Programmierung, Ingenieurwesen, Wissenschaft und Sprachen. Jeder mit Niveau und Laboranforderungen.",
  "step2.title": "Einschreiben & sicher zahlen",
  "step2.body":
    "Stripe-Bezahlung in deiner Währung. Ein Kurs beginnt erst, wenn die Mindestkohorte erreicht ist — dein Platz ist reserviert.",
  "step3.title": "Buche deine Zeit",
  "step3.body":
    "Wähle aus dem Kalender deines Lehrers. Nimm live per Laptop teil, oder per Handy (außer Programmierkurse).",
  "step4.title": "Hol dir das Zertifikat",
  "step4.body":
    "Schließe das Curriculum ab und dein Lehrer stellt ein überprüfbares EDUHUB-Zertifikat aus.",
  "course.beginner": "Anfänger",
  "course.intermediate": "Mittelstufe",
  "course.advanced": "Fortgeschritten",
  "course.viewDetails": "Details ansehen",
  "course.enroll": "Einschreiben",
  "course.enrolled": "Eingeschrieben",
  "course.minStudents": "Min. Kohorte",
  "course.hours": "Stunden",
  "course.laptopRequired": "Laptop erforderlich",
  "course.phoneAllowed": "Handy oder Laptop",
  "footer.tagline": "Eine Premium-Akademie von MikkSysTech.",
  "footer.copy": "© 2026 EDUHUB. Alle Rechte vorbehalten.",
  "footer.discipl": "Disziplinen",
  "footer.company": "Unternehmen",
  "footer.legal": "Rechtliches",
  "auth.email": "E-Mail",
  "auth.password": "Passwort",
  "auth.name": "Vollständiger Name",
  "auth.signin": "Anmelden",
  "auth.signup": "Konto erstellen",
  "auth.haveAccount": "Hast du schon ein Konto?",
  "auth.noAccount": "Neu bei EDUHUB?",
  "common.loading": "Lädt…",
  "common.search": "Kurse suchen",
  "common.allLevels": "Alle Niveaus",
  "common.allCategories": "Alle Disziplinen",
  "courses.eyebrow": "Alle Kurse",
  "courses.title": "Der Katalog.",
  "courses.subtitle":
    "Siebenundvierzig Live-Kurse in zehn Disziplinen. Wähle ein Niveau. Reserviere deinen Platz.",
  "course.from": "Ab",
  "course.enrolledLabel": "eingeschrieben",
  "course.toCohort": "bis Kohorte",
};

const IT = {
  "nav.courses": "Corsi",
  "nav.playground": "Laboratorio",
  "nav.howItWorks": "Come funziona",
  "nav.about": "Chi siamo",
  "nav.dashboard": "Bacheca",
  "nav.admin": "Admin",
  "nav.signin": "Accedi",
  "nav.enroll": "Iscriviti",
  "nav.signout": "Esci",
  "hero.eyebrow": "EDUHUB — Una scuola di MikkSysTech",
  "hero.title.line1": "Insegnamento classico.",
  "hero.title.line2": "Mestiere moderno.",
  "hero.body":
    "Lezioni dal vivo in piccole coorti, tenute da veri professionisti. Da Python ai sistemi di potenza, dal rumeno alla robotica — costruito come un’università, al ritmo di una startup.",
  "hero.cta.primary": "Sfoglia i corsi",
  "hero.cta.secondary": "Come funziona",
  "hero.typing.prefix": "Stiamo insegnando",
  "section.categories": "Discipline",
  "section.featured": "In primo piano questo semestre",
  "section.how": "Come funziona EDUHUB",
  "step1.title": "Scegli la tua disciplina",
  "step1.body":
    "Quarantasette corsi in programmazione, ingegneria, scienze e lingue. Ciascuno con livello e requisiti di laboratorio.",
  "step2.title": "Iscriviti e paga in sicurezza",
  "step2.body":
    "Pagamento Stripe nella tua valuta. Un corso inizia solo quando si raggiunge la coorte minima — il tuo posto è prenotato.",
  "step3.title": "Prenota il tuo orario",
  "step3.body":
    "Scegli dal calendario del tuo docente. Partecipa dal vivo da laptop o telefono (escluso programmazione).",
  "step4.title": "Ottieni il certificato",
  "step4.body":
    "Completa il programma e il tuo docente rilascia un certificato EDUHUB verificabile.",
  "course.beginner": "Principiante",
  "course.intermediate": "Intermedio",
  "course.advanced": "Avanzato",
  "course.viewDetails": "Vedi dettagli",
  "course.enroll": "Iscriviti",
  "course.enrolled": "Iscritto",
  "course.minStudents": "Coorte min.",
  "course.hours": "ore",
  "course.laptopRequired": "Laptop richiesto",
  "course.phoneAllowed": "Telefono o laptop",
  "footer.tagline": "Un’accademia premium di MikkSysTech.",
  "footer.copy": "© 2026 EDUHUB. Tutti i diritti riservati.",
  "footer.discipl": "Discipline",
  "footer.company": "Azienda",
  "footer.legal": "Note legali",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.name": "Nome completo",
  "auth.signin": "Accedi",
  "auth.signup": "Crea account",
  "auth.haveAccount": "Hai già un account?",
  "auth.noAccount": "Nuovo su EDUHUB?",
  "common.loading": "Caricamento…",
  "common.search": "Cerca corsi",
  "common.allLevels": "Tutti i livelli",
  "common.allCategories": "Tutte le discipline",
  "courses.eyebrow": "Tutti i corsi",
  "courses.title": "Il catalogo.",
  "courses.subtitle":
    "Quarantasette corsi live in dieci discipline. Scegli un livello. Prenota il tuo posto.",
  "course.from": "Da",
  "course.enrolledLabel": "iscritti",
  "course.toCohort": "verso coorte",
};

export const translations = { en: EN, ro: RO, es: ES, fr: FR, de: DE, it: IT };

export const LANG_OPTIONS = [
  { value: "en", label: "English",  flag: "🇬🇧" },
  { value: "ro", label: "Română",   flag: "🇷🇴" },
  { value: "es", label: "Español",  flag: "🇪🇸" },
  { value: "fr", label: "Français", flag: "🇫🇷" },
  { value: "de", label: "Deutsch",  flag: "🇩🇪" },
  { value: "it", label: "Italiano", flag: "🇮🇹" },
];
